/* ============================================================
   Make Your Own Sticker — Sticker Calculator
   Connects to sticker-configurator Node.js server for pricing.
   Layout: StickerMule-style — image gallery left, config right.
   ============================================================ */

(function () {
  'use strict';

  // ── Per-product size presets [width, height, label] ───────
  const SIZE_PRESETS = {
    'die-cut':         [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[5,5,'5" × 5"']],
    'kiss-cut':        [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[4,6,'4" × 6"']],
    'circle':          [[1.5,1.5,'1.5"'],[2,2,'2"'],[3,3,'3"'],[4,4,'4"']],
    'rectangle':       [[2,4,'2" × 4"'],[3,5,'3" × 5"'],[4,6,'4" × 6"'],[6,4,'6" × 4"']],
    'square':          [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[5,5,'5" × 5"']],
    'oval':            [[2,3,'2" × 3"'],[3,4,'3" × 4"'],[4,5,'4" × 5"']],
    'bumper':          [[3,10,'3" × 10"'],[3,11.5,'3" × 11.5"'],[4,15,'4" × 15"']],
    'sticker-sheets':  [[4,6,'4" × 6"'],[5,7,'5" × 7"'],[8,10,'8" × 10"'],[8.5,11,'8.5" × 11"']],
    'rounded-corner':  [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[4,6,'4" × 6"']],
    'clear':           [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[5,5,'5" × 5"']],
    'holographic':     [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[5,5,'5" × 5"']],
    'glitter':         [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"']],
    'transfer':        [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[4,6,'4" × 6"']],
    'vinyl-lettering': [[2,12,'2" × 12"'],[4,12,'4" × 12"'],[6,24,'6" × 24"']],
    'window-clings':   [[4,4,'4" × 4"'],[6,6,'6" × 6"'],[8,8,'8" × 8"'],[10,10,'10" × 10"']],
    'front-adhesive':  [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"']],
    'fabric':          [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"']],
    'economy':         [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"'],[5,5,'5" × 5"']],
    'sticker-packs':   [[2,2,'2" × 2"'],[3,3,'3" × 3"'],[4,4,'4" × 4"']],
  };

  const SHAPE_CLASS = {
    'die-cut':'die-cut','kiss-cut':'kiss-cut','circle':'circle','oval':'oval',
    'square':'square','rectangle':'rectangle','bumper':'bumper',
    'rounded-corner':'rounded','sticker-sheets':'sheet','clear':'die-cut',
    'holographic':'die-cut','glitter':'die-cut','transfer':'die-cut',
    'fabric':'die-cut','vinyl-lettering':'rectangle','window-clings':'square',
    'front-adhesive':'die-cut','economy':'die-cut','sticker-packs':'die-cut',
  };

  const SWATCH = {
    'gloss':       '#d4eef5',
    'matte':       '#c8d6dc',
    'clear':       'linear-gradient(135deg,rgba(200,230,240,0.35) 0%,rgba(255,255,255,0.15) 100%)',
    'holographic': 'linear-gradient(135deg,#ff6ec7,#ffe14d,#6ef7ff,#a56eff)',
    'glitter':     'linear-gradient(135deg,#ffd700 0%,#c0c0c0 50%,#ffd700 100%)',
    'window':      'linear-gradient(135deg,rgba(150,210,240,0.35) 0%,rgba(255,255,255,0.75) 100%)',
    'front':       'linear-gradient(135deg,rgba(190,220,240,0.4) 0%,rgba(255,255,255,0.85) 100%)',
    'transfer':    '#2e2e2e',
    'fabric':      '#c9b69a',
    'economy':     '#ececec',
    'vinyl':       '#d4eef5',
    'default':     '#d4eef5',
  };

  const FINISH_KEY = {
    'gloss':'gloss','matte':'matte','clear':'clear',
    'holographic':'holographic','holo':'holographic',
    'glitter':'glitter','transfer':'gloss','fabric':'gloss',
    'economy':'gloss','vinyl':'gloss','window':'clear','cling':'clear',
    'front':'clear','adhesive':'clear',
  };

  // Default finish to show on preview panel per product type
  const TYPE_FINISH = {
    'glitter':'glitter','holographic':'holographic',
    'clear':'clear','window-clings':'clear','front-adhesive':'clear',
  };

  // Default material to prioritise in the materials list per product type
  const TYPE_MAT_KEY = {
    'glitter':       'glitter',
    'holographic':   'holographic',
    'clear':         'clear',
    'window-clings': 'window',
    'front-adhesive':'front',
  };

  const QTY_PRESETS = [25, 50, 100, 250, 500, 1000, 2500, 5000];

  const FALLBACK = {
    base_price_per_sqin: 0.12,
    currency_symbol: '$',
    min_qty: 25,
    max_qty: 5000,
    materials: [
      { id:1, name:'Gloss Vinyl',    description:'Vibrant glossy finish',           multiplier:1.00, enabled:1 },
      { id:2, name:'Matte Vinyl',    description:'Smooth non-glare finish',         multiplier:1.10, enabled:1 },
      { id:3, name:'Clear',          description:'Transparent background',          multiplier:1.25, enabled:1 },
      { id:4, name:'Holographic',    description:'Eye-catching rainbow shimmer',    multiplier:1.75, enabled:1 },
      { id:5, name:'Glitter',        description:'Sparkle vinyl with glitter shine',multiplier:1.60, enabled:1 },
      { id:6, name:'Window Cling',   description:'Static cling — removes cleanly',  multiplier:1.20, enabled:1 },
      { id:7, name:'Front Adhesive', description:'Clear vinyl applied from front',  multiplier:1.30, enabled:1 },
    ],
    tiers: [
      { min_qty:1,    max_qty:24,   discount_pct:0  },
      { min_qty:25,   max_qty:49,   discount_pct:5  },
      { min_qty:50,   max_qty:99,   discount_pct:10 },
      { min_qty:100,  max_qty:249,  discount_pct:20 },
      { min_qty:250,  max_qty:499,  discount_pct:30 },
      { min_qty:500,  max_qty:999,  discount_pct:40 },
      { min_qty:1000, max_qty:null, discount_pct:50 },
    ],
  };

  // ── Calculator ────────────────────────────────────────────
  class StickerCalculator {
    constructor(el) {
      this.el           = el;
      this.serverUrl    = (el.dataset.serverUrl || '').replace(/\/$/, '');
      this.type         = el.dataset.stickerType || 'die-cut';
      this.label        = el.dataset.stickerLabel || 'Custom Sticker';
      this.config       = null;
      this.animFrame    = null;
      this.animFrom     = 0;
      this.activeImage  = 0;

      // Product data from Liquid
      try {
        this.images = JSON.parse(el.dataset.productImages || '[]');
      } catch (_) {
        this.images = [];
      }
      this.productTitle = el.dataset.productTitle || '';
      this.productDesc  = el.dataset.productDesc  || '';

      const presets = SIZE_PRESETS[this.type] || SIZE_PRESETS['die-cut'];
      const def     = presets[1] || presets[0];
      this.state = {
        width: def[0], height: def[1],
        quantity: 100,
        materialId: null,
        customSize: false,
        customQty: false,
      };
    }

    async init() {
      await this._loadConfig();
      this._render();
      this._bind();
      this._updateAll();
    }

    // ── Config ─────────────────────────────────────────────
    async _loadConfig() {
      if (this.serverUrl) {
        try {
          const res = await fetch(this.serverUrl + '/api/config', {
            signal: AbortSignal.timeout(5000),
          });
          if (res.ok) {
            const data = await res.json();
            if (data.materials?.length) { this.config = data; }
          }
        } catch (_) {}
      }
      if (!this.config) this.config = JSON.parse(JSON.stringify(FALLBACK));

      const matOverride = this.el.dataset.materials;
      if (matOverride) {
        const allowed = matOverride.split(',').map(s => s.trim().toLowerCase());
        this.config.materials = this.config.materials.filter(m =>
          allowed.some(a => m.name.toLowerCase().includes(a))
        );
      }
      if (!this.config.materials.length) this.config.materials = FALLBACK.materials;

      // Prioritise the product-type-specific material (e.g. Glitter first for glitter-stickers)
      const typeMatKey = TYPE_MAT_KEY[this.type];
      if (typeMatKey) {
        const idx = this.config.materials.findIndex(m => m.name.toLowerCase().includes(typeMatKey));
        if (idx > 0) {
          const [mat] = this.config.materials.splice(idx, 1);
          this.config.materials.unshift(mat);
        }
      }

      this.state.materialId = this.config.materials[0].id;
      const minQty          = this.config.min_qty || 25;
      this.state.quantity   = QTY_PRESETS.find(q => q >= minQty) || minQty;
    }

    // ── Render ─────────────────────────────────────────────
    _render() {
      const presets = SIZE_PRESETS[this.type] || SIZE_PRESETS['die-cut'];
      const hasImages = this.images.length > 0;

      // Product title breadcrumb (only on product pages)
      const titleHtml = this.productTitle
        ? `<div class="smb-calc__product-header">
             <a class="smb-calc__breadcrumb" href="/collections/all">All Stickers</a>
             <span class="smb-calc__breadcrumb-sep">›</span>
             <span class="smb-calc__breadcrumb-current">${this.productTitle}</span>
           </div>`
        : '';

      // Description below the calculator (only on product pages)
      const descHtml = this.productDesc
        ? `<div class="smb-calc__description">
             <p>${this.productDesc}</p>
             <div class="smb-calc__features">
               <div class="smb-calc__feature"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Weatherproof vinyl</div>
               <div class="smb-calc__feature"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Free digital proof</div>
               <div class="smb-calc__feature"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Ships in 3–5 days</div>
               <div class="smb-calc__feature"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Dishwasher-safe</div>
             </div>
           </div>`
        : '';

      this.el.innerHTML = `
        ${titleHtml}
        <div class="smb-calc__inner${hasImages ? ' smb-calc__inner--with-images' : ''}">
          ${hasImages ? this._html_gallery() : this._html_preview()}
          <div class="smb-calc__config">
            ${this._html_size(presets)}
            ${this._html_qty()}
            ${this._html_materials()}
            ${this._html_cta()}
          </div>
        </div>
        ${descHtml}`;
    }

    // ── Gallery panel (when product images exist) ─────────
    _html_gallery() {
      const img = this.images[0] || {};
      const dots = this.images.length > 1
        ? `<div class="smb-calc__gallery-dots">
             ${this.images.map((_, i) =>
               `<button class="smb-calc__gallery-dot${i === 0 ? ' active' : ''}" data-img="${i}"></button>`
             ).join('')}
           </div>`
        : '';
      const nav = this.images.length > 1
        ? `<button class="smb-calc__gallery-prev" aria-label="Previous">
             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg>
           </button>
           <button class="smb-calc__gallery-next" aria-label="Next">
             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M9 18l6-6-6-6"/></svg>
           </button>`
        : '';

      return `
        <div class="smb-calc__gallery">
          <div class="smb-calc__gallery-main">
            <img id="smb-gallery-img"
                 src="${img.src || ''}"
                 alt="${this.productTitle}"
                 loading="eager">
            ${nav}
          </div>
          ${dots}
          <div class="smb-calc__price-box smb-calc__price-box--gallery">
            <div class="smb-calc__price-total" id="smb-total">$0.00</div>
            <div class="smb-calc__price-unit"  id="smb-unit">calculating…</div>
            <div class="smb-calc__price-badge" id="smb-badge"></div>
          </div>
        </div>`;
    }

    // ── Shape preview panel (homepage demo / no images) ───
    _html_preview() {
      const shapeClass = SHAPE_CLASS[this.type] || 'die-cut';
      // Derive initial finish from the first (type-prioritised) material
      const firstMatName = (this.config.materials?.[0]?.name || '').toLowerCase();
      const finishKey    = Object.keys(FINISH_KEY).find(k => firstMatName.includes(k));
      const initFinish   = TYPE_FINISH[this.type] || FINISH_KEY[finishKey] || 'gloss';
      return `
        <div class="smb-calc__preview">
          <div class="smb-calc__preview-eyebrow">Live Preview</div>
          <div class="smb-calc__canvas">
            <div id="smb-shape"
                 class="smb-calc__shape smb-calc__shape--${shapeClass}"
                 data-finish="${initFinish}"
                 style="width:90px;height:90px"></div>
          </div>
          <div class="smb-calc__dims" id="smb-dims">
            ${this.state.width}" × ${this.state.height}"
          </div>
          <div class="smb-calc__price-box">
            <div class="smb-calc__price-total" id="smb-total">$0.00</div>
            <div class="smb-calc__price-unit"  id="smb-unit">calculating…</div>
            <div class="smb-calc__price-badge" id="smb-badge"></div>
          </div>
        </div>`;
    }

    _html_size(presets) {
      const isCircle = ['circle', 'window-clings'].includes(this.type);
      const def = presets[1] || presets[0];

      const btnHtml = presets.map(([w, h, lbl]) => {
        const active = (w === def[0] && h === def[1]) ? 'active' : '';
        return `<button class="smb-calc__size-btn ${active}"
                        data-w="${w}" data-h="${h}">${lbl}</button>`;
      }).join('');

      const customInputs = isCircle
        ? `<label>DIA</label>
           <input id="smb-cw" type="number" min="0.5" max="48" step="0.5"
                  value="${this.state.width}" placeholder="0">
           <span class="sep">"</span>`
        : `<label>W</label>
           <input id="smb-cw" type="number" min="0.5" max="48" step="0.5"
                  value="${this.state.width}" placeholder="0">
           <span class="sep">" ×</span>
           <label>H</label>
           <input id="smb-ch" type="number" min="0.5" max="48" step="0.5"
                  value="${this.state.height}" placeholder="0">
           <span class="sep">"</span>`;

      return `
        <div class="smb-calc__step">
          <div class="smb-calc__step-num">1</div>
          <div class="smb-calc__step-title">Choose Your Size</div>
          <div class="smb-calc__sizes">
            ${btnHtml}
            <button class="smb-calc__size-btn" data-custom="1">Custom</button>
          </div>
          <div class="smb-calc__custom-row" id="smb-custom-size">
            ${customInputs}
          </div>
        </div>`;
    }

    _html_qty() {
      const tiers  = this.config.tiers || [];
      const minQty = this.config.min_qty || 25;

      const pillHtml = QTY_PRESETS
        .filter(q => q >= minQty)
        .map(q => {
          const tier   = tiers.find(t => q >= t.min_qty && (!t.max_qty || q <= t.max_qty));
          const pct    = tier?.discount_pct || 0;
          const active = q === this.state.quantity ? 'active' : '';
          const badge  = pct > 0 ? `<span class="smb-badge">-${pct}%</span>` : '';
          return `<button class="smb-calc__qty-btn ${active}" data-qty="${q}">${q}${badge}</button>`;
        }).join('');

      const tierHtml = tiers
        .filter(t => t.discount_pct > 0)
        .map(t => {
          const maxLbl = t.max_qty ? `${t.min_qty}–${t.max_qty}` : `${t.min_qty}+`;
          return `<div class="smb-calc__tier-row" data-min="${t.min_qty}">
                    <span>${maxLbl} stickers</span>
                    <span>Save ${t.discount_pct}%</span>
                  </div>`;
        }).join('');

      return `
        <div class="smb-calc__step">
          <div class="smb-calc__step-num">2</div>
          <div class="smb-calc__step-title">Choose Quantity</div>
          <div class="smb-calc__qty-pills">${pillHtml}</div>
          ${tierHtml ? `<div class="smb-calc__tier-strip">${tierHtml}</div>` : ''}
          <div class="smb-calc__custom-qty-row">
            <label>Custom qty:</label>
            <input id="smb-cqty" type="number"
                   min="${minQty}" max="${this.config.max_qty || 5000}"
                   placeholder="Enter qty">
          </div>
        </div>`;
    }

    _html_materials() {
      const mats = (this.config.materials || []).filter(m => m.enabled);
      const cards = mats.map(m => {
        const key     = Object.keys(SWATCH).find(k => m.name.toLowerCase().includes(k)) || 'default';
        const sw      = SWATCH[key];
        const swStyle = sw.startsWith('linear') ? `background:${sw}` : `background-color:${sw}`;
        const active  = m.id === this.state.materialId ? 'active' : '';
        return `
          <button class="smb-calc__mat-btn ${active}"
                  data-id="${m.id}" data-name="${m.name}">
            <div class="smb-calc__mat-swatch" style="${swStyle}"></div>
            <div class="smb-calc__mat-name">${m.name}</div>
            <div class="smb-calc__mat-desc">${m.description || ''}</div>
          </button>`;
      }).join('');

      return `
        <div class="smb-calc__step">
          <div class="smb-calc__step-num">3</div>
          <div class="smb-calc__step-title">Choose Finish</div>
          <div class="smb-calc__materials">${cards}</div>
        </div>`;
    }

    _html_cta() {
      const cartIcon = `<svg width="19" height="19" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/></svg>`;
      const check = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <polyline points="20 6 9 17 4 12"/></svg>`;
      return `
        <div class="smb-calc__cta-card">
          <button id="smb-add-btn" class="smb-calc__add-btn">
            ${cartIcon} Add to Cart
          </button>
          <div class="smb-calc__trust-row">
            <div class="smb-calc__trust-item">${check} Free digital proof</div>
            <div class="smb-calc__trust-item">${check} Ships in 3–5 days</div>
            <div class="smb-calc__trust-item">${check} Free shipping $50+</div>
          </div>
        </div>`;
    }

    // ── Events ─────────────────────────────────────────────
    _bind() {
      const el = this.el;

      // Image gallery navigation
      el.querySelector('.smb-calc__gallery-prev')?.addEventListener('click', () => {
        this.activeImage = (this.activeImage - 1 + this.images.length) % this.images.length;
        this._updateGallery();
      });
      el.querySelector('.smb-calc__gallery-next')?.addEventListener('click', () => {
        this.activeImage = (this.activeImage + 1) % this.images.length;
        this._updateGallery();
      });
      el.querySelectorAll('.smb-calc__gallery-dot').forEach(dot => {
        dot.addEventListener('click', () => {
          this.activeImage = parseInt(dot.dataset.img);
          this._updateGallery();
        });
      });

      // Size presets
      el.querySelectorAll('.smb-calc__size-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          el.querySelectorAll('.smb-calc__size-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          if (btn.dataset.custom) {
            this.state.customSize = true;
            this._q('smb-custom-size')?.classList.add('show');
          } else {
            this.state.customSize = false;
            this.state.width  = parseFloat(btn.dataset.w);
            this.state.height = parseFloat(btn.dataset.h);
            this._q('smb-custom-size')?.classList.remove('show');
            this._updateAll();
          }
        });
      });

      this._q('smb-cw')?.addEventListener('input', e => {
        this.state.width = Math.max(0.5, parseFloat(e.target.value) || 0.5);
        this._updateAll();
      });
      this._q('smb-ch')?.addEventListener('input', e => {
        this.state.height = Math.max(0.5, parseFloat(e.target.value) || 0.5);
        this._updateAll();
      });

      el.querySelectorAll('.smb-calc__qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.state.quantity  = parseInt(btn.dataset.qty);
          this.state.customQty = false;
          el.querySelectorAll('.smb-calc__qty-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const inp = this._q('smb-cqty');
          if (inp) inp.value = '';
          this._updateAll();
        });
      });

      this._q('smb-cqty')?.addEventListener('input', e => {
        const v = parseInt(e.target.value);
        if (v >= (this.config.min_qty || 25)) {
          this.state.quantity  = v;
          this.state.customQty = true;
          el.querySelectorAll('.smb-calc__qty-btn').forEach(b => b.classList.remove('active'));
          this._updateAll();
        }
      });

      el.querySelectorAll('.smb-calc__mat-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.state.materialId = parseInt(btn.dataset.id);
          el.querySelectorAll('.smb-calc__mat-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const shape   = this._q('smb-shape');
          const nameKey = Object.keys(FINISH_KEY).find(k => btn.dataset.name.toLowerCase().includes(k));
          if (shape) shape.dataset.finish = FINISH_KEY[nameKey] || 'gloss';
          this._updateAll();
        });
      });

      this._q('smb-add-btn')?.addEventListener('click', () => this._checkout());
    }

    // ── Gallery update ─────────────────────────────────────
    _updateGallery() {
      const img = this.images[this.activeImage];
      if (!img) return;
      const imgEl = this._q('smb-gallery-img');
      if (imgEl) {
        imgEl.style.opacity = '0';
        imgEl.src = img.src;
        imgEl.onload = () => { imgEl.style.opacity = '1'; };
      }
      this.el.querySelectorAll('.smb-calc__gallery-dot').forEach((dot, i) => {
        dot.classList.toggle('active', i === this.activeImage);
      });
    }

    // ── Calculations ────────────────────────────────────────
    _calc() {
      const { width, height, quantity, materialId } = this.state;
      const { base_price_per_sqin = 0.12, materials = [], tiers = [] } = this.config;
      const mat      = materials.find(m => m.id === materialId) || materials[0];
      const area     = width * height;
      const tier     = tiers.find(t => quantity >= t.min_qty && (!t.max_qty || quantity <= t.max_qty)) || { discount_pct: 0 };
      const disc     = (tier.discount_pct || 0) / 100;
      const baseUnit = base_price_per_sqin * area * (mat?.multiplier || 1);
      const unitPrice= baseUnit * (1 - disc);
      const total    = unitPrice * quantity;
      return { unitPrice, total, savingsPct: tier.discount_pct || 0, mat };
    }

    _updateAll() {
      this._updatePreview();
      this._updatePrice();
      this._updateTiers();
    }

    _updatePreview() {
      const { width, height } = this.state;
      const shape = this._q('smb-shape');
      const dims  = this._q('smb-dims');
      if (shape) {
        const maxDim = Math.max(width, height, 0.5);
        const scale  = Math.min(150, 150 / maxDim);
        shape.style.width  = Math.round(width  * scale) + 'px';
        shape.style.height = Math.round(height * scale) + 'px';
      }
      if (dims) dims.textContent = `${width}" × ${height}"`;
    }

    _updatePrice() {
      const { unitPrice, total, savingsPct } = this._calc();
      const sym   = this.config.currency_symbol || '$';
      const badge = this._q('smb-badge');
      this._animateTo(total, sym);
      const unitEl = this._q('smb-unit');
      if (unitEl) unitEl.textContent = `${sym}${unitPrice.toFixed(2)} per sticker`;
      if (badge) {
        if (savingsPct > 0) {
          badge.textContent = `Save ${savingsPct}%`;
          badge.classList.add('show');
        } else {
          badge.classList.remove('show');
        }
      }
    }

    _updateTiers() {
      const { quantity } = this.state;
      this.el.querySelectorAll('.smb-calc__tier-row').forEach(row => {
        row.classList.toggle('active', quantity >= parseInt(row.dataset.min));
      });
    }

    _animateTo(target, sym) {
      const start    = this.animFrom;
      const duration = 280;
      let startTs    = null;
      const el       = this._q('smb-total');
      if (!el) { this.animFrom = target; return; }
      if (this.animFrame) cancelAnimationFrame(this.animFrame);
      const tick = (ts) => {
        if (!startTs) startTs = ts;
        const p    = Math.min((ts - startTs) / duration, 1);
        const ease = 1 - Math.pow(1 - p, 3);
        el.textContent = sym + (start + (target - start) * ease).toFixed(2);
        if (p < 1) this.animFrame = requestAnimationFrame(tick);
        else { this.animFrom = target; el.textContent = sym + target.toFixed(2); }
      };
      this.animFrame = requestAnimationFrame(tick);
    }

    // ── Checkout ────────────────────────────────────────────
    async _checkout() {
      const btn = this._q('smb-add-btn');
      if (!btn) return;

      const { width, height, quantity } = this.state;
      const { unitPrice, total, mat }   = this._calc();

      btn.classList.add('loading');
      btn.textContent = 'Processing…';

      if (this.serverUrl) {
        try {
          const res = await fetch(this.serverUrl + '/api/checkout', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              shape: this.label, width, height,
              material_name: mat?.name || 'Gloss Vinyl',
              quantity, unit_price: unitPrice.toFixed(2),
            }),
          });
          const data = await res.json();
          if (data.checkout_url) { window.location.href = data.checkout_url; return; }
          throw new Error(data.error || 'Checkout unavailable');
        } catch (err) { this._showError(btn, err.message); return; }
      }

      const variantId = this.el.dataset.variantId;
      if (!variantId) {
        this._showError(btn, 'No product linked yet — check back soon!');
        return;
      }

      const properties = {
        'Sticker Type': this.label,
        'Width':        width + '"',
        'Height':       height + '"',
        'Finish':       mat?.name || 'Gloss Vinyl',
        'Quantity':     quantity + ' units',
        'Unit Price':   '$' + unitPrice.toFixed(2),
        'Order Total':  '$' + total.toFixed(2),
      };

      try {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: Math.max(1, Math.round(total * 100)), properties }),
        });
        if (!res.ok) throw new Error('Could not add to cart');
        window.location.href = '/cart';
      } catch (err) { this._showError(btn, err.message); }
    }

    _showError(btn, msg) {
      btn.classList.remove('loading');
      btn.innerHTML = `&#9888;&#xFE0F; ${msg}`;
      setTimeout(() => {
        btn.innerHTML = `<svg width="19" height="19" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 01-8 0"/>
        </svg> Add to Cart`;
      }, 4000);
    }

    _q(id) { return this.el.querySelector('#' + id); }
  }

  function initAll() {
    document.querySelectorAll('.smb-calculator').forEach(el => {
      if (el.dataset.smbInit) return;
      el.dataset.smbInit = '1';
      new StickerCalculator(el).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.StickerCalculator = StickerCalculator;
})();
